import { getStatusDescriptionFromStatusValue, getOrderTypeText } from '../../../../../utils/utility';
import { getDateWithSpecificFormat } from '../../../../data-transform';

const hardwarePaymentStatusOptions = [
    {
        "id": "HARDWARE_PAYMENT_TO_HP_PENDING",
        "label": "Hardware Payment To HP Pending"
    },
    {
        "id": "HARDWARE_PAYMENT_TO_HP_TRIGGERED",
        "label": "Hardware Payment To HP Triggered"
    },
    {
        "id": "HARDWARE_PAYMENT_TO_HP_COMPLETED",
        "label": "Hardware Payment To HP Completed"
    }
]

const hardware2PaymentStatusOptions = [
    {
        "id": "HARDWARE_PAYMENT_TO_PARTNER_PENDING",
        "label": "Hardware Payment To Partner Pending"
    },
    {
        "id": "HARDWARE_PAYMENT_TO_PARTNER_TRIGGERED",
        "label": "Hardware Payment To Partner Triggered"
    },
    {
        "id": "HARDWARE_PAYMENT_TO_PARTNER_COMPLETED",
        "label": "Hardware Payment To Partner Completed"
    }
]

const servicePaymentStatusOptions = [
    {
        "id": "SERVICE_PAYMENT_TO_PARTNER_PENDING",
        "label": "Service Payment To Partner Pending"
    },
    {
        "id": "SERVICE_PAYMENT_TO_PARTNER_TRIGGERED",
        "label": "Service Payment To Partner Triggered"
    },
    {
        "id": "SERVICE_PAYMENT_TO_PARTNER_COMPLETED",
        "label": "Service Payment To Partner Completed"
    },
]

const servicePaymentStatusDirectNet = [
    {
        "id": "PAYMENT_TO_HP_PENDING",
        "label": "Payment to HP Pending"
    },
    {
        "id": "PAYMENT_TO_HP_TRIGGERED",
        "label": "Payment to HP Triggered"
    },
    {
        "id": "PAYMENT_TO_HP_COMPLETED",
        "label": "Payment to HP Completed"
    },
]

const invoiceStatusOptionsAll = [
    {
        "id": "PENDING",
        "label": "Pending"
    },
    {
        "id": "APPROVED",
        "label": "Approved"
    },
    {
        "id": "REJECTED",
        "label": "Rejected"
    },
    {
        "id": "PAID",
        "label": "Paid"
    }
]

const invoiceStatusOptionsNotPaid = [
    {
        "id": "APPROVED",
        "label": "Approved"
    },
    {
        "id": "REJECTED",
        "label": "Rejected"
    },
    {
        "id": "PAID",
        "label": "Paid"
    }
]

const invoiceStatusOptionsPaid = [
    {
        "id": "PAID",
        "label": "Paid"
    }
]

const getPaymentStatus = (paymentStatus, transactionType, partnerAmount) => {
    let options = [];
    if (transactionType === 'Hardware' || (transactionType === 'Hardware2' && partnerAmount > 0)) {
        let isAvailabel = hardwarePaymentStatusOptions.findIndex((item) => item.id === paymentStatus)
        options = (isAvailabel >= 0) ? hardwarePaymentStatusOptions.slice(isAvailabel + 1) : [...hardwarePaymentStatusOptions];
    }
    if (transactionType === 'Service' || transactionType === 'Service1' || transactionType === 'Service2' || transactionType === 'Revitalize fees') {
        let isAvailabel = servicePaymentStatusOptions.findIndex((item) => item.id === paymentStatus)
        options = (isAvailabel >= 0) ? servicePaymentStatusOptions.slice(isAvailabel + 1) : [...servicePaymentStatusOptions];
    }
    if (transactionType === 'Direct net' || transactionType === 'Indirect net') {
        let isAvailabel = servicePaymentStatusDirectNet.findIndex((item) => item.id === paymentStatus)
        options = (isAvailabel >= 0) ? servicePaymentStatusDirectNet.slice(isAvailabel + 1) : [...servicePaymentStatusDirectNet];
    }
    if (transactionType === 'Service2') {
        let isAvailabel = hardwarePaymentStatusOptions.findIndex((item) => item.id === paymentStatus)
        if (isAvailabel >= 0) {
            options = hardwarePaymentStatusOptions.slice(isAvailabel + 1)
        }
    }
    if (transactionType === 'Hardware2' && partnerAmount < 0) {
        let isAvailabel = hardware2PaymentStatusOptions.findIndex((item) => item.id === paymentStatus)
        options = (isAvailabel >= 0) ? hardware2PaymentStatusOptions.slice(isAvailabel + 1) : [...hardware2PaymentStatusOptions];
    }
    return options;
}

const getInvoiceStatusOptions = (invoiceStatus) => {
    let options = []
    if (invoiceStatus === "PENDING") {
        options = [...invoiceStatusOptionsAll]
    } else if (invoiceStatus === "APPROVED" || invoiceStatus === "REJECTED") {
        options = [...invoiceStatusOptionsNotPaid]
    } else if (invoiceStatus === "PAID") {
        options = [...invoiceStatusOptionsPaid]
    }
    return options;
}

export default function partnerFinancialsColumnsSpecification(config) {
    if (!config.data) return null;

    let result = {};
    let tableData = [];
    const { userType } = config.data;

    config.data.financialList.forEach((order, index) => {
        let row = [];
        const rowId = order.orderId + "|" + order.paymentStatus + "|" + index;

        config.columns.forEach(column => {
            const columnId = column.id;
            const displayAsIs = column.data.displayInBodyAsIs;
            let columnDataType = column.data.displayInBodyAs;
            let columnValue = null;
            let clickHandler = null;
            let columnValueData = null;
            let importantData = null;
            let isDisabled = false;

            if (columnDataType === "string") {
                if (columnId === "orderId") {
                    columnValue = order.orderId || "";
                }
                else if (columnId === "orderType") {
                    columnValue = getOrderTypeText(order.orderType) || "";
                }
                else if (columnId === "company") {
                    columnValue = order.company || "";
                }
                else if (columnId === "legalEntity") {
                    columnValue = order.legalEntity || "";
                }
                else if (columnId === "reportsDate") {
                    columnValue = getDateWithSpecificFormat(order.reportAvailableDate) || "";
                }
                else if (columnId === "hpReportingDate") {
                    columnValue = getDateWithSpecificFormat(order.hpReportingDate) || "";
                }
                else if (columnId === "transactionType") {
                    columnValue = order.lineType || "";
                }
                else if (columnId === "HPPartner") {
                    columnValue = order.vendorName || "";
                }
                else if (columnId === "customerPaymentType") {
                    columnValue = order.customerPaymentType || "";
                }
                else if (columnId === "partnerAmount") {
                    columnValue = order.vendorAmount === null ? "" : order.vendorAmount;
                }
                else if (columnId === "currencyCode") {
                    columnValue = order.currencyCode || "";
                }
                else if (columnId === "revitalizeOrder") {
                    columnValue = order.revitalizeOrder || "";
                }
                else if (columnId === "revitalizeQuote") {
                    columnValue = order.revitalizeQuote || "";
                }
            }
            else if (columnDataType === "input") {
                columnValueData = { ...column.data };
                clickHandler = config.bodyButtonsHandler ? event => config.bodyButtonsHandler(event, columnId, index) : null;
                if (columnId === "serviceInvoiceDate") {
                    columnValue = order.partnerInvoiceDate || "";
                    columnValueData.defaultValue = columnValue;
                    columnValueData.disableBeforeDates = [order.reportAvailableDate];
                    // if (order.paymentDate) {
                    //     isDisabled = true;
                    // }
                }
                if (columnId === "hwInvoiceDate") {
                    columnValue = order.paymentDate || "";
                    columnValueData.defaultValue = columnValue;
                    columnValueData.disableBeforeDates = [order.partnerInvoiceDate];
                    // if (order.invoiceStatus !== "PAID") {
                    //     isDisabled = true;
                    // }
                    // else if (order.paymentStatus === "HARDWARE_PAYMENT_TO_HP_PENDING") {
                    //     isDisabled = true;
                    // }
                }
                else if (columnId === "s4OrderNumberForPartner") {
                    columnValue = order.s4OrderNumberForPartner || "";
                    columnValueData.defaultValue = columnValue;
                    // isDisabled = userType === 'ControlTower' ? false : true;
                }
                else if (columnId === "partnerInvoiceNo") {
                    columnValue = order.partnerInvoiceNo;
                    columnValueData.defaultValue = columnValue;
                    // if (order.invoiceStatus === "PAID" || order.lineType === "Hardware" || order.lineType === "Hardware1" || order.lineType === "Hardware2") {
                    //     isDisabled = true;
                    // }
                }
                else if (columnId === "partnerPONo") {
                    columnValue = order.partnerPONo;
                    columnValueData.defaultValue = columnValue;
                    // if (order.invoiceStatus === "PAID" || order.lineType === "Service") {
                    //     isDisabled = true;
                    // }
                }
                else if (columnId === "hpInvoiceNoPartner") {
                    columnValue = order.hpInvoiceNo;
                    columnValueData.defaultValue = columnValue;
                    // if (order.invoiceStatus === "PAID" || order.lineType === "Service") {
                    //     isDisabled = true;
                    // }
                }
                else if (columnId === "hpPONo") {
                    columnValue = order.hpPONo || "";
                    columnValueData.defaultValue = columnValue;
                    if (order.invoiceStatus === "PAID") {
                        isDisabled = true;
                    }
                }
                else if (columnId === "hpPONoForPartner") {
                    columnValue = order.hpPONo || "";
                    columnValueData.defaultValue = columnValue;
                    // if (order.invoiceStatus === "PAID") {
                    //     isDisabled = true;
                    // }
                }
                else if (columnId === "revitalizeOrder") {
                    columnValue = getStatusDescriptionFromStatusValue(order.revitalizeOrder) || "";
                }
            }
            else if (columnDataType === "select") {
                if (columnId === "partnerPaymentStatus") {
                    columnValue = order.paymentStatus || ""
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    columnValueData.options = [{ id: order.paymentStatus, label: getStatusDescriptionFromStatusValue(order.paymentStatus) }, ...getPaymentStatus(columnValue, order.lineType, order.vendorAmount)]
                    clickHandler = config.bodyButtonsHandler ? event => config.bodyButtonsHandler(event, columnId, index) : null;
                    if (order.invoiceStatus === "PAID") {
                        isDisabled = true;
                    }
                }
                if (columnId === "invoiceStatus") {
                    columnValue = order.invoiceStatus || "";
                    columnValueData = { ...column.data };

                    columnValueData.defaultValue = columnValue;
                    columnValueData.options = [...getInvoiceStatusOptions(columnValue)]
                    if (order.invoiceStatus === null) {
                        columnValueData.options = [...getInvoiceStatusOptions("PENDING")]
                    }
                    if (order.paymentType === "DRV Net Payment") {
                        columnValueData.options = [...getInvoiceStatusOptions("PENDING")]
                    }
                    if (order.invoiceStatus === "PAID") {
                        isDisabled = true;
                    }
                    if (order.paymentStatus === "HARDWARE_PAYMENT_TO_HP_PENDING") {
                        isDisabled = true;
                    }
                    if (userType === 'Vendor') {
                        isDisabled = true;
                    }
                }
                clickHandler = config.bodyButtonsHandler ? event => config.bodyButtonsHandler(event, columnId, index) : null;
            }
            row.push({
                [columnId]: {
                    id: columnId + "|" + rowId,
                    columnId: columnId,
                    type: columnDataType,
                    value: columnValueData || columnValue,
                    disabled: isDisabled,
                    width: column.width,
                    displayAsIs: displayAsIs,
                    clickHandler: clickHandler,
                    importantData: importantData,
                    showInMobileViewAs: column.showInMobileViewAs,
                    isGlobal: order.paymentStatus === "SERVICE_PAYMENT_TO_HP_PENDING" && order.paymentType === "HP Payment + HP2B" ? true : false
                }
            });
        });
        tableData.push({
            id: rowId,
            data: row
        });
    })

    result['columns'] = config.columns || [];
    result['data'] = tableData || [];
    return result;
}
